<template>
  <div id="pc-psp-container">
    <div class="mt-2 mb-3 border-bottom-line pb-4">
      <product-search-header :initialSelectedFilters="initialSelectedFilters"></product-search-header>
    </div>
    <div class="wf-page-controls mt-4 mt-lg-0 ">
      <div class="wf-page-controls-items-new align-items-baseline">
        <div class="wf-page-control-item wf-page-control-item-current-refinements">
          <div class="d-flex cursor-pointer" @click="hideShowFilters">
            <div class="text-uppercase font-size-18"> {{ toggleButton ? showFilter : hideFilter }}</div>
            <span class="png-icon png-icon-icons-glyph--k-sort-filter ml-3"></span>
          </div>
        </div>
        <div class="
            wf-page-control-item wf-page-control-item-product-display-controls
          "
        >
          <wf-product-display-controls />
        </div>

      </div>
    </div>

    <div class="wf-product-category-new">
      <div class="wf-product-category-sidebar-mobile">
        <div class="wf-side-collapse" id="filters-side-collapse">
          <div class="wf-side-collapse-header justify-content-end">
            <button class="wf-side-collapse-button wf-side-collapse-button-close btn" type="button">
              {{ $resourceString["product.search.close.button"] }}
              <span class="png-icon png-icon-icons-glyph--g-close" aria-label="close button" />
            </button>
          </div>
          <div class="wf-side-collapse-body">
            <div class="wf-side-collapse-section border-bottom-line">
              <current-filters @clearAllFilters="clearAllFilters"/>
            </div>
            <div class="wf-side-collapse-section">
              <side-filters/>
            </div>
          </div>
        </div>
      </div>

      <div class="wf-product-category-sidebar-desktop mt-2" v-if="!toggleButton">
        <div class="flex column border-bottom-line">
            <current-filters @clearAllFilters="clearAllFilters"/>
        </div>
        <side-filters/>
      </div>

      <div class="wf-product-category-results">
        <div class="wf-product-category-results">
          <section class="">
            <div class="">
              <div class="wf-product-category-results">
                <div class="wf-search-results wf-search-results-view-mode-swatch"
                     :class="[`wf-search-results-tile-size-${tileSize}`]" :key="tileSize"
                >
                  <pc-gtm-event-logger :key="items.length" 
                                        :product-impressions="items"
                                       :product-impression-filter="getFilterObject()" 
                                       :event-name="GTMEventName"
                                       :product-impression-start-index="(pageNumber - 1) * pageSize"
                                       :product-impression-image-type="viewMode"
                                       :selected-filters ="selectedFilters"
                                       :in-stock = "inStock"
                                       :filter-by-face-weight = "filterByFaceWeight"
                  />

                  <product-search-result
                    v-for="(item, index) in items"
                    :item="item"
                    :key="itemKey(item.styleNumber)"
                    :product-index="index"
                    :is-compare="true"
                    :toggle-button="toggleButton"
                  />
                  <pc-load-more v-if="showLoadMore" :load-more="onLoadMore" />
                </div>
                <p v-if="items.length === 0 && !isFetching">
                  {{ $resourceString["common.noResults"] }}
                </p>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { initialize } from "../../../scripts/wf-side-collapse";
import WFProductDisplayControls from "../wf-product-display-controls.vue";
import SideFilters from "./pc-side-filters.vue";
import ProductSearchResult from "./pc-product-search-result.vue";
import CurrentFilters from "./pc-product-search-current-filters.vue";
import PcLoadMore from "../common/pc-loading-more.vue";
import PCGTMEventLogger from "../pc-gtm-event-logger.vue";
import { PRODUCT_IMPRESSION_EVENT_NAME } from "../../../constants/gtm-constants";
import ProductSearchHeader from "./pc-product-header.vue"

export default {
  props: ["initialSelectedFilters"],
  components: {
    "wf-product-display-controls": WFProductDisplayControls,
    SideFilters,
    ProductSearchResult,
    CurrentFilters,
    PcLoadMore,
    "pc-gtm-event-logger": PCGTMEventLogger,
    ProductSearchHeader,
  },
  data() {
    return {
      carbonAzureName: "Sustainability",
      GTMEventName: PRODUCT_IMPRESSION_EVENT_NAME,
      containerHeights: [0],
      currentHeightIndex: 0,
      sharedCompare: false,
      toggleButton: false,
      showFilter : this.$resourceString['product.Search.Filters.Button.Show'],
      hideFilter : this.$resourceString['product.Search.Filters.Button.Hide']
    };
  },
  computed: {
    ...mapGetters({
      items: "productDisplay/items",
      pageNumber: "productDisplay/pageNumber",
      sortOrder: "filters/sortOrder",
      isAscendingOrder: "filters/isAscendingOrder",
      selectedFilters: "filters/selectedFilters",
      pageSize: "productDisplay/pageSize",
      inStock: "filters/inStock",
      isFetching: "productDisplay/isFetching",
      showLoadMore: "productDisplay/showLoadMore",
      tileSize: "filters/tileSize",
      searchTerm: "filters/searchTerm",
      faceWeightValue: "filters/faceWeightValue",
      filterByFaceWeight: "filters/filterByFaceWeight",
      carbonFilters: "filters/carbonFilters",
      selections: "filters/selections",
      faceWeightMin: "filters/faceWeightMin",
      faceWeightMax: "filters/faceWeightMax",
      viewMode: "filters/viewMode",
      searchParams: "filters/searchParams"
    }),
    changedData() {
      return `${this.sortOrder}
        |${this.selectedFilters}|${this.inStock}|${this.filterByFaceWeight}
        |${this.searchTerm}|${this.isAscendingOrder}|${this.faceWeightValue}`;
    },
  },
  methods: {
    ...mapActions({
      setInitialSelectedFilters: "filters/setInitialSelectedFilters",
      fetchResults: "productDisplay/fetchResults",
      setPageNumber: "productDisplay/setPageNumber",
      setSearchTerm: "filters/setSearchTerm",
      setFiltersFromURL: "filters/setFiltersFromURL",
      setFiltersInURL: "filters/setFiltersInURL",
      clearAllFilters: "filters/clearAllFilters",
      showPdfPopup: "compareModal/showPdfPopup"
    }),

    backgroundColor() {
      document.body.style.backgroundColor = '#ffffff';
    },

    hideShowFilters(){
      this.toggleButton = !this.toggleButton;
    },

    onLoadMore() {
      if (this.isFetching) {
        return;
      }
      this.setPageNumber(this.pageNumber + 1);
      this.onSearch();

      const urlSearchParams = new URLSearchParams(window.location.search);
      if (!urlSearchParams.has('searchTerm')) this.trackProductContainerHeights();
    },
    onSearch() {
      this.fetchResults({
        filter: this.getFilterObject()
      });
    },
    getFilterObject() {
      return {
        ...this.selections,
        ...this.carbonFilters,
        OrderColumn: this.sortOrder,
        PageNumber: this.pageNumber,
        IncludeTotalResultCount: true,
        PageSize: this.pageSize,
        InStock: this.inStock,
        SearchTerm: this.searchTerm,
        IsAscendingOrder: this.isAscendingOrder === "asc",
        IsEnabledOnSite: true,
        IsDisabledOnSearch: false,
        FaceWeightMin: this.faceWeightMin,
        FaceWeightMax: this.faceWeightMax,
        IsPSP: true
      };
    },
    updateURl(param, value) {
      const url = new URL(window.location.href);
      url.searchParams.set(param, value);
      window.history.replaceState({}, "", url);
    },
    trackPageNumberInURL() {
      // Track the current page number in the URL based on the scroll position of the page
      if (this.containerHeights && this.containerHeights.length > 0) {
        const scrollPosition = window.scrollY;
        // Find the index of the first element in containerHeights that is greater than the current scroll position
        const index = this.containerHeights.findIndex(height => scrollPosition < height);
        // If an appropriate index is found and it is different from the current index, update the current index and the URL
        if (index >= 0 && this.currentHeightIndex !== index) {
          this.currentHeightIndex = index;
          this.updateURl("Page", this.currentHeightIndex + 1);
        }
      }
    },
    trackProductContainerHeights() {
      let resultsContainerHeight = document.getElementById('vue-wf-product-category').clientHeight;

      // Check if new height is within range of existing height values
      let withinRange = false;
      for (let i = 0; i < this.containerHeights.length; i++) {
        if (Math.abs(this.containerHeights[i] - resultsContainerHeight) < 1000) {
          withinRange = true;
          break;
        }
      }

      if (!withinRange) {
        this.containerHeights.push(resultsContainerHeight);
        this.containerHeights.sort((a, b) => a - b);
        sessionStorage.setItem('containerHeights', JSON.stringify(this.containerHeights));
      }
    },
    async scrollToLastPosition() {

      const urlSearchParams = new URLSearchParams(window.location.search);
      const ProductId = urlSearchParams.get('ProductId');
      const lastScrollPosition = window.scrollY;
      // Create a promise that resolves when the product data is loaded
      const productDataPromise = new Promise((resolve) => {
        const checkProductData = setInterval(() => {
          const products = document.getElementsByClassName('wf-search-result description');
          if (products.length > 0) {
            clearInterval(checkProductData);
            resolve(products);
          }
        }, 1000);
      });
      // Wait for the promise to resolve before scrolling to the last position
      const products = await productDataPromise;
      const matchingProduct = Array.from(products).find((product) => product.id === ProductId);
      if (matchingProduct) {
        const top = matchingProduct.getBoundingClientRect().top + lastScrollPosition;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    },
    setSharedCompareProducts() {
      if (location.search) {
        const urlParams = new URLSearchParams(location.search);
        let params = {};
        urlParams.forEach((value, key) => {
          params[key] = value;
        });
        if (params["CompareProducts"]) {
          document.cookie =
            "compareProducts=" +
            params["CompareProducts"] +
            ";path=/";
          this.sharedCompare = true;
        }

        if (params["DownloadDocs"]) {
          this.showPdfPopup();
        }
      }
    },
    itemKey(styleNumber) {
      return `${styleNumber}-${this.toggleButton}`;
    }
  },
  mounted() {
    this.backgroundColor();
    const element = document.getElementById("product-display-view-type-room");
    if (element && element.scrollIntoView) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    if (this.searchParams) {
      this.setFiltersFromURL();
    }
    else if (this.initialSelectedFilters) {
      this.setInitialSelectedFilters(
        Object.fromEntries(
          Object.entries(JSON.parse(this.initialSelectedFilters)).map(
            ([k, v]) => [k[0].toUpperCase() + k.slice(1), v]
          )
        )
      );
    }
    // Retrieve the container heights from session storage
    const containerHeightsString = sessionStorage.getItem('containerHeights');
    if (containerHeightsString) {
      this.containerHeights = [];
      this.containerHeights = JSON.parse(containerHeightsString);
    }
    window.addEventListener('scroll', this.trackPageNumberInURL);
    this.scrollToLastPosition();
    this.setSharedCompareProducts();
    initialize();
    if (this.sharedCompare === true) {
      this.$store.dispatch("compareModal/open");
    }
  },
  watch: {
    changedData: {
      handler: function () {
        this.setPageNumber(1);
        this.onSearch();
        this.setFiltersInURL("OriginalActivationDate");
      },
      deep: true,
    },
  },
};
</script>

<style></style>
